import React, { useState, useRef } from "react";
import { Modal, TextInput, Button, Group, Select } from "@mantine/core";
import classes from "./add.module.css";
import { RowDataNotification } from "./types";

interface AddNotificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddNotification: (newNotificationData: RowDataNotification) => void;
}

const AddNotificationModal: React.FC<AddNotificationModalProps> = ({
  isOpen,
  onClose,
  onAddNotification,
}) => {
  const [newNotification, setNewNotification] = useState<RowDataNotification>({
    id: "",
    title: "",
    body: "",
    type: "",
    route: "",
    send: false,
    action: "Edit",
  });

  const handleAddNotification = () => {
    // Check if any required fields are empty
    if (
      !newNotification.title ||
      !newNotification.body ||
    //   newNotification.type === ""
    !newNotification.route
    ) {
      alert("Please fill in all the required fields");
      return;
    }

    onAddNotification(newNotification);

    // Clear inputs and reset state
    setNewNotification({
      id: "",
      title: "",
      body: "",
      type: "",
      route: "",
      send: false,
      action: "Edit",
    });

    onClose();
  };

  const handleClose = () => {
    // Clear inputs and reset state
    setNewNotification({
      id: "",
      title: "",
      body: "",
      type: "",
      route: "",
      send: false,
      action: "Edit",
    });

    // Call the onClose function
    onClose();
  };

  return (
    <Modal
      style={{ zIndex: "100" }}
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          New Notification
        </div>
      }
      opened={isOpen}
      onClose={handleClose}
    >
      <TextInput
        label="Title"
        placeholder="Input a title"
        mb="sm"
        required={true}
        maxLength={255}
        value={newNotification.title}
        onChange={(event) =>
          setNewNotification({
            ...newNotification,
            title: event.currentTarget.value,
          })
        }
      />

      <TextInput
        label="Body"
        placeholder="Input body"
        mb="sm"
        required={true}
        maxLength={255}
        value={newNotification.body}
        onChange={(event) =>
          setNewNotification({
            ...newNotification,
            body: event.currentTarget.value,
          })
        }
      />

      {/* <Select
        label="Type"
        placeholder="Input type"
        mb="sm"
        searchable
        data={["React", "Angular", "Vue", "Svelte"]}
        required={true}
        onChange={(value, option) =>
          setNewNotification({ ...newNotification, type: value ?? "" })
        }
      /> */}

        <Select
            label="Route"
            placeholder="Select route"
            required
            defaultValue={'Home'}
            data={[
                { value: 'Home', label: 'Home' },

                { value: 'ViewnetCash', label: 'ViewnetCash' },
                { value: 'MyQR', label: 'MyQR' },
                { value: 'Rewards', label: 'Rewards' },
                { value: 'Me', label: 'Me' },

                { value: 'Membership', label: 'Membership' },
                { value: 'MyVouchers', label: 'MyVouchers' },
                { value: 'MyPurchases', label: 'MyPurchases' },
                { value: 'FAQ', label: 'FAQ' },
                { value: 'TermsOfUse', label: 'TermsOfUse' },
                { value: 'PrivacyPolicy', label: 'PrivacyPolicy' },
                { value: 'PriceList', label: 'PriceList' },
                { value: 'DailyFeed', label: 'DailyFeed' },
                { value: 'MyMerchandise', label: 'MyMerchandise' },

                { value: 'CashHistory', label: 'CashHistory' },
                { value: 'CoinHistory', label: 'CoinHistory' },

                { value: 'Notification', label: 'Notification' },
            ]}
            onChange={(value, option) =>
                setNewNotification({ ...newNotification, route: value })
            }
        />

      <Group className={classes.buttonBottom}>
        <Button onClick={() => onClose()} className={classes.buttonBack}>
          Back
        </Button>
        <Button
          onClick={handleAddNotification}
          className={classes.buttonSubmit}
        >
          Submit
        </Button>
      </Group>
    </Modal>
  );
};

export default AddNotificationModal;
